import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap';
import { auth } from "../../firebase/firebase-config";
import firebase from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import 'react-toastify/dist/ReactToastify.css';
import { toast, Toast, ToastContainer } from 'react-toastify';
import { updateToken } from '../../authPages/BaseRequester';
import { v4 as uuidv4 } from 'uuid';

const SingleUser = ({ data, verificationPage }) => {
    const [Currentuser, loading] = useAuthState(auth);
    const [user, setuser] = useState({})
    const [total_orders, settotal_orders] = useState([])
    const [total_Earnings, setEarnings] = useState([])
    const [total_Products, settotal_Products] = useState([])
    const [total_orders_earnings, settotal_orders_earnings] = useState(0)
    const [total_orders_delivered, settotal_orders_delivered] = useState([])


    const get_user = async () => {
        await firebase.firestore().collection('users').doc(data.id).onSnapshot((user) => {

            setuser(user.data());


        })
    }

    useEffect(() => {

        // var blocked_users = [];
        // firebase.firestore().collection('BlockedUsers').onSnapshot((data) => {
        //     data.forEach((user) => {
        //         blocked_users.push(user.data());
        //     })
        //     // console.log(blocked_users)
        //     setAllBlockedUsers(blocked_users);
        // })
        get_user();
        var Order_users = [];
        firebase.firestore().collection('orders').where('userId', '==', data?.id).onSnapshot((snapdata) => {
            snapdata.forEach((order) => {
                Order_users.push(order.data());
            })
            settotal_orders(Order_users);
        })
        var Product_users = [];
        firebase.firestore().collection('post').where('addedById', '==', data?.id).onSnapshot((snapdata) => {
            snapdata.forEach((postproduct) => {
                Product_users.push(postproduct.data());
            })
            settotal_Products(Product_users);
        })




    }, [user])



    const getUserAllEarnings = async () => {
        await firebase.firestore().collection('earnings').doc(data?.id).collection('totalEarnings').onSnapshot(async (snapdata) => {

            const totalSalesQuantity = [];
            const monthlyEarningsALL = [];
            await snapdata.docs.map(async (month) => {

                totalSalesQuantity.push(month?.data()['totalQuantitySold']);
                const resultTotalSales = await totalSalesQuantity.reduce((a, v) => a = a + v, 0)
                settotal_orders_delivered(resultTotalSales);
                // console.log(totalSalesQuantity, 'this is totalsalesq');
                const monthEarnings = month?.data()['totalEarnings'];
                monthlyEarningsALL.push(monthEarnings);
                const result = await monthlyEarningsALL.reduce((a, v) => a = a + v, 0)
                setEarnings(result);

                await firebase.firestore().collection('earnings').doc(data?.id).collection('totalEarnings')
                    .doc(month?.id).collection('earnings').onSnapshot(async (monthlyEarning) => {

                        // monthlyEarning.docs.map(async (e) => {
                        //     const totalearning = await e.data()['price'] * e.data()['quantity'];
                        //     await monthlyEarningsALL.push(totalearning);
                        //     const result = await monthlyEarningsALL.reduce((a, v) => a = a + v, 0)
                        //     setEarnings(result);
                        // });

                    })

                console.log(resultTotalSales, 'this is totalsalesq');
            })

        })

    }


    useEffect(() => {
        console.log(verificationPage);
        // firebase.firestore().collection('orders').where('userId', '==', data?.id).where('isCompleted', '==', true).where('status', '==', 'delivered').get().then((snapdata) => {
        //     var total_amount = [];
        //     // console.log(snapdata);
        //     snapdata.forEach((order_amount) => {
        //         total_amount.push(order_amount.data()['amount']);

        //     })
        //     console.log(total_amount);
        //     const result = total_amount.reduce((a, v) => a = a + v, 0)
        //     console.log(result);

        //     settotal_orders_earnings(result);
        // })
        // var orders_delivered = [];
        // firebase.firestore().collection('orders').where('userId', '==', data?.id).where('status', '==', 'delivered').onSnapshot((snapdata) => {
        //     snapdata.forEach((order) => {
        //         orders_delivered.push(order.data());
        //     })
        //     settotal_orders_delivered(orders_delivered);
        // })




        getUserAllEarnings();



    }, [])

    let formatter = Intl.NumberFormat('en', { notation: 'compact' });

    // console.log(formatter.format(1000));
    return (



        <Col md="4">
            <Card className="card-user shadow-lg">
                <CardBody className='pb-0'>
                    <CardText />
                    <div className="Single_author">
                        <div className="block block-one" />
                        <div className="block block-two" />
                        <div className="block block-three" />
                        <div className="block block-four" />
                        <div className="d-flex justify-content-between  " >
                            <div className=" d-flex ">
                                <img
                                    alt="..."
                                    className="avatar_single_user"
                                    src={data?.profilePicture}
                                />
                                {/* <div>{user?.isOnline == false ? <div className="px-4 d-flex justify-content-center align-items-center  font-weight-bolder" style={{ backgroundColor: '#DD011B', borderRadius: '20px' }}> <p className='font-weight-bold'>Ofline</p>    </div> : <div className="px-4 d-flex justify-content-center align-items-center " style={{ backgroundColor: '#30DF1E', borderRadius: '20px' }}> <p className="font-weight-bold">Online</p>    </div>}
                                </div> */}
                                <div className="ml-2 mt-2">
                                    <div className='d-flex'>
                                        <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{data?.username}</p>
                                    </div>
                                    <p className="description" style={{ fontSize: '12px' }}>{data.fullName}</p>

                                </div>

                            </div>
                            <p className="description" style={{ fontSize: '14px' }}>Beyown user</p>


                        </div>


                        {/* <div className="d-flex justify-content-around align-items-center">
                                <p className="font-weight-bolder">Followers: {user_followers == 0 ? 0 : user_followers} </p>
                                <p className="font-weight-bolder">Followings: {user_followings == 0 ? 0 : user_followings} </p>

                            </div> */}
                    </div>
                    {verificationPage != false ? <div className=' mb-4' style={{ overflow: 'scroll', height: '200px' }}>
                        {data?.visaId.map((visadata, i) => {
                            return <div className='d-flex justify-content-between  border-bottom  rounded my-2 align-items-center  p-2' key={visadata}>
                                <p style={{ fontSize: '18px' }}>{i == 0 ? 'Front Side' : 'Back Side'}</p>
                                <div style={{ height: '80px' }}>
                                    <a href={visadata} target='_blank'>
                                        <img src={visadata} className="image-fluid" style={{ height: '100%', width: '100%' }} />
                                    </a>
                                </div>
                            </div>
                        })}
                    </div> : <div className="">
                        {/* {user?.bio == '' ? 'There is no bio' : user?.bio} */}

                        <div className="d-flex justify-content-center align-items-center">

                            <Card className=" shadow-lg bg-primary mr-1" style={{ background: 'linear-gradient(to right, #00b4db, #0083b0)' }}
                            //  style={{ height: '70%', width: '100%' }}
                            >
                                <CardBody className="d-flex flex-column justify-content-between">
                                    <div >
                                        <p className="font-weight-bolder title">Total Products</p>
                                        <p className="description font-weight-bolder" style={{ fontSize: '26px' }}> <Link to={`/admin/Total-Products/${data?.id}/All-Products`} >{formatter.format(total_Products.length)}</Link></p>
                                    </div>
                                    <div >
                                        <p className="font-weight-bolder title">Total Orders</p>
                                        <p className="description font-weight-bolder" style={{ fontSize: '26px' }}><Link to={`/admin/Total-Orders/${data?.id}/All-Orders`} >{formatter.format(total_orders.length)}</Link></p>
                                    </div>
                                </CardBody>

                            </Card>



                            <Card className=" shadow-lg bg-primary ml-1" style={{ background: 'linear-gradient(to right, #4e54c8, #8f94fb)' }}
                            //  style={{ height: '70%', width: '100%' }}
                            >
                                <CardBody className="d-flex flex-column justify-content-between ">

                                    <div>
                                        <p className="font-weight-bolder title">Total Earnings</p>
                                        <p className="description font-weight-bolder" style={{ fontSize: '26px' }}>{formatter.format(total_Earnings)} AED</p>
                                        <Link to={`/admin/SingleUser/MonthlyEarnings/${data?.id}`} className="btn btn-sm btn-primary rounded  " ><p>Monthly Earnings</p></Link>
                                    </div>
                                    <div>
                                        <p className="font-weight-bolder title">Total Sales(quantity)</p>
                                        <p className="description font-weight-bolder" style={{ fontSize: '26px' }}>{formatter.format(total_orders_delivered)}</p>
                                    </div>

                                </CardBody>

                            </Card>

                        </div>





                    </div>}

                </CardBody>
                <CardFooter className='pt-0'>
                    <div className='mb-2'>
                        Account Verified :  {data?.visaIdVerificationState == 'pending' ? <span className='bg-primary text-white px-3 py-1 rounded '>Pending Verification</span> : data?.visaIdVerificationState == 'verified' ? <span className='bg-success  px-3 py-1 rounded'>Verified</span> : <span className='bg-secondary   px-3 py-1 rounded'>Not Uploaded</span>}
                    </div>

                    <div className="button-container">
                        <Link to={`/admin/total-beyown-users/single_user/${data?.id}`} className="btn btn-sm btn-round" color="facebook">
                            See Profile
                        </Link>
                        {

                            user?.isDisabled == true ? <Button className="btn btn-success btn-sm btn-round" color="twitter" onClick={async (e) => {

                                e.preventDefault();
                                var token = await updateToken();


                                let config = {
                                    headers: {
                                        "Content-type": "application/json",
                                        "Authorization": `Bearer ${token}`,
                                    },
                                }
                                const url = `https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/disableAnyUser/${data?.id}`;
                                console.log(url);

                                await axios.put(url, null, config).then((succ) => {
                                    console.log(succ);
                                    // firebase.firestore().collection('BlockedUsers').doc(data?.id).delete();
                                    toast.success('User Profile Has been Enabled', {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "dark",
                                    })


                                }).catch((error) => {
                                    console.log(error.response.data)
                                });






                            }}>
                                Enable Profile
                            </Button> : <Button className="btn btn-danger btn-sm btn-round" color="twitter" onClick={async (e) => {
                                console.log('pressed');
                                e.preventDefault();
                                var token = await updateToken();

                                // const tokens = await firebase.auth().currentUser.getIdToken(true).then((token) => {
                                //     console.log(token);
                                // });
                                // console.log(tokens);


                                // let config = {
                                //     headers: {
                                //         "Content-type": "application/json",
                                //         "Authorization": `Bearer ${token}`,
                                //     },
                                // }
                                const config = {
                                    headers: { "Authorization": `Bearer ${token}` }
                                }

                                axios.put(`https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/disableAnyUser/${data?.id}`, null, config).then((succ) => {

                                    // firebase.firestore().collection('BlockedUsers').doc(data?.id).set({ uid: data?.id });
                                    toast.success(`User Profile Has been Disabled`, {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "dark",
                                    })

                                }).catch((error) => {
                                    console.log(error.response.data)
                                });



                            }}>
                                Disable Profile
                            </Button>


                        }
                        {
                            verificationPage != false && data?.visaIdVerificationState == 'pending' ? <Button to={`/admin/total-beyown-users/single_user/${data?.id}`} className="btn btn-sm btn-round bg-danger " onClick={async (e) => {
                                e.preventDefault();
                                firebase.firestore().collection('users').doc(data?.id).update({
                                    'visaIdVerificationState': 'verified'
                                })

                                var token = await updateToken();
                                const header = `Authorization: Bearer ${token}`;
                                const config = {
                                    headers: { "Authorization": `Bearer ${token}` }
                                }
                                const uuid =
                                    uuidv4();
                                var NotificaitonData = {
                                    id: uuid,
                                    title: `Beyown Account Verification Status`,
                                    message: `Yahoo! Your Account For Beyown has been verified Successfully, Tap to view more...`,
                                    icon: "",
                                    topics: "",
                                    data: {},
                                    type: "follow",
                                    // senderId: "",
                                    userId: data?.id,
                                }
                                axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

                            }}  >
                                Verify User
                            </Button> : verificationPage != false && data?.visaIdVerificationState == 'verified' ? <Button to={`/admin/total-beyown-users/single_user/${data?.id}`} className="btn btn-sm btn-round bg-danger " onClick={async (e) => {
                                e.preventDefault();

                                firebase.firestore().collection('users').doc(data?.id).update({
                                    'visaIdVerificationState': 'pending'
                                })
                                var token = await updateToken();
                                const header = `Authorization: Bearer ${token}`;
                                const config = {
                                    headers: { "Authorization": `Bearer ${token}` }
                                }
                                const uuid =
                                    uuidv4();
                                var NotificaitonData = {
                                    id: uuid,
                                    title: `Beyown Account Verification Status`,
                                    message: `Your Verification for Beyown account has been revoked Due to malicious activity, Tap to view more...`,
                                    icon: "",
                                    topics: "",
                                    data: {},
                                    type: "follow",
                                    // senderId: "",
                                    userId: data?.id,
                                }
                                axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)

                            }}  >
                                Remove Verification
                            </Button> : <div></div>
                        }
                        <Link className="btn " to={`/admin/CreateGiftCards/${data?.id}`} >Create GiftCard</Link>

                        {/* Make collection of disabled/blacklist users then add disabled users inside then get full collection in array and check if UID is inside array ....iff inside show enable button else disable button */}


                    </div>
                </CardFooter>
            </Card>
        </Col >


    );
}


export default SingleUser;